import "./Commons.scss";
import {
  Card,
  Layout,
  Button,
  notification,
  Skeleton,
  Col,
  Row,
  Empty,
  Space,
  Table,
  Flex,
  Modal,
} from "antd";
import React, { useEffect, useState } from "react";
import type { TableProps } from "antd";
import { useParams } from "react-router-dom";
import {
  DeleteOutlined,
  FormOutlined,
  PlusOutlined,
  ShareAltOutlined,
} from "@ant-design/icons";
import Search from "antd/es/input/Search";
import { useSelector } from "react-redux";
import {
  CommonsMessages,
  CommonsRaw,
  PageSetting,
  Query,
  SortMode,
} from "../../..";
import MenuBar from "../../../components/Menu/MenuBar";
import Footer from "../../../components/Footer/Footer";
import store from "../../../../controllers/store";
import { find } from "../../../../controllers/store/actions/commons/get-commons-actions";
import { findById } from "../../../../controllers/store/actions/commons/update-commons-actions";
import { findActorById } from "../../../../controllers/store/actions/actorTypes/get-actorType-by-id-action";
import { remove } from "../../../../controllers/store/actions/commons/delete-common-action";
import { clear } from "../../../../controllers/store/actions/commons/create-common-action";
import NewCommonModal from "../../../components/Forms/Modal/Commons/NewCommon";
import UpdateCommonModal from "../../../components/Forms/Modal/Commons/UpdateCommon";
import DependencyModal from "../../../components/Forms/Modal/Dependency/DependencyModal";

const { confirm } = Modal;
const { Header, Content } = Layout;
const dispatch = store.dispatch;

const query: Query = { filter: {} };
const Commons: React.FC = () => {
  let { actor } = useParams();
  const [visibleCreateModal, setVisibleCreateModal] = useState(false);
  const [visibleUpdateModal, setVisibleUpdateModal] = useState(false);
  const [visibleShowDependencyModal, setVisibleShowDepencyModal] =
    useState(false);
  const [data, setData] = useState<any>({});
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(PageSetting.limit);
  const [api, contextHolder] = notification.useNotification();
  const commonsState = useSelector((state: any) => state.commons);
  const updatedCommonState = useSelector((state: any) => state.updatedCommon);
  const deletedCommonState = useSelector((state: any) => state.deletedCommon);
  const createdCommonState = useSelector((state: any) => state.createdCommon);
  const actorTypeState = useSelector((state: any) => state.getActorType);
  const userState = useSelector((state: any) => state.user.user);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const showDependencies = (value: any) => {
    setData(value);
    setVisibleShowDepencyModal(true);
  };

  const columns: TableProps<CommonsRaw>["columns"] = [
    {
      title: "Nombre",
      dataIndex: "nombre",
      key: "nombre",
      width: 150,
    },
    {
      title: "Dependencias",
      dataIndex: "dependencie_value",
      key: "dependencie_value",
      render(_, record: any) {
        if (record.dependencie_value) {
          return (
            <Button
              onClick={() => {
                showDependencies(record);
              }}
              icon={<ShareAltOutlined />}
              type="primary"
              size={"small"}
            >
              Ver dependencias
            </Button>
          );
        }

        return (
          <Button
            disabled={true}
            icon={<ShareAltOutlined />}
            type="default"
            size={"small"}
          >
            Sin dependencia
          </Button>
        );
      },
    },
    {
      title: "Email",
      dataIndex: "contact_email",
      key: "contact_email",
    },
    {
      title: "Teléfono",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Ciudad",
      dataIndex: "ciudad",
      key: "ciudad",
    },
    {
      title: "Fuente",
      dataIndex: "source",
      key: "source",
    },
    {
      title: "Reconocimiento MinCiencia",
      dataIndex: "recognized_min",
      key: "recognized_min",
    },
    {
      title: "Fecha de expedición",
      dataIndex: "issue_date",
      key: "issue_date",
    },
    {
      title: "Vigencia",
      dataIndex: "current_date",
      key: "current_date",
    },
    {
      title: "Última actualización",
      dataIndex: "updated_at",
      key: "updated_at",
    },
    {
      title: "Acciones",
      key: "action",
      fixed: "right",
      width: 250,
      render: (_, record: CommonsRaw) => (
        <Space size="middle">
          <Button
            type="primary"
            onClick={() => {
              if (record.id) {
                dispatch(findById(record.id));
              }
              setVisibleUpdateModal(!visibleUpdateModal);
            }}
            size="small"
            icon={<FormOutlined />}
          >
            Modificar
          </Button>
          <Button
            type="default"
            onClick={() => {
              confirm({
                okType: "primary",
                okText: "Borrar",
                cancelText: "Cancelar",
                title: CommonsMessages.Title,
                content: CommonsMessages.CommonsConfirmDeleteMessage,
                onOk: async () => {
                  if (record.id) {
                    await dispatch(remove(record.id));
                    dispatch(find(page, pageSize, query));
                  }
                },
                onCancel() {},
              });
            }}
            size="small"
            icon={<DeleteOutlined />}
          >
            Eliminar
          </Button>
        </Space>
      ),
    },
  ];

  const showCreatedCommonsMessageSuccess = () => {
    api["success"]({
      key: 1,
      message: CommonsMessages.Title,
      description: CommonsMessages.CommonsCreated,
    });
    dispatch(clear());
    return null;
  };

  const showDeletedCommonsMessage = () => {
    api["success"]({
      key: 1,
      message: CommonsMessages.Title,
      description: CommonsMessages.CommonsDeleteSuccessMessage,
    });

    dispatch(clear());
    return null;
  };

  const showUpdatedCommonsMessage = () => {
    api["success"]({
      key: 1,
      message: CommonsMessages.Title,
      description: CommonsMessages.CommonsUpdateSuccessMessage,
    });

    dispatch(clear());
    return null;
  };

  useEffect(() => {
    //query.filter.user = `&filter[user_created][_eq]=${userState.me.id}&deep=true&filter[actor_type][_eq]=${actor}`;
    dispatch(find(1, pageSize, { filter: { actor_type: actor } }));
    if (actor) {
      dispatch(findActorById(actor));
      setInitialDataLoaded(true);
    }
  }, [pageSize]);

  const handleSearch = (value: string) => {
    setSearchTerm(value);
    if (value) {
      query.search = value;
      query.meta = "filter_count";
    } else {
      delete query.search;
    }
    dispatch(find(1, pageSize, query));
  };

  return (
    <Layout className="commons-layout">
      {contextHolder}
      {createdCommonState.createdCommon
        ? showCreatedCommonsMessageSuccess()
        : null}
      {deletedCommonState.removed ? showDeletedCommonsMessage() : null}
      {updatedCommonState.updatedCommon ? showUpdatedCommonsMessage() : null}
      <MenuBar />
      <Header className="bg-header-profile" />
      <Content className="commons-content">
        <DependencyModal
          data={data}
          visible={visibleShowDependencyModal}
          onCancel={() => setVisibleShowDepencyModal(false)} // Manejar el cierre del modal aquí
        />
        <Card className="commons-card">
          <Col xs={24} sm={12} md={8} lg={12}>
            <h1 className="heading-content-title">
              Entidad
              <span className="heading-content-subtitle">{`${
                actorTypeState?.actorType?.actor || "Entidad"
              }`}</span>
            </h1>
          </Col>
          <br />
          <NewCommonModal
            actorType={actorTypeState.actorType}
            visible={visibleCreateModal}
            onCreated={() => {
              setVisibleCreateModal(false);
              dispatch(find(page, pageSize, query));
            }}
            onCancel={() => {
              setVisibleCreateModal(false);
            }}
          />
          <UpdateCommonModal
            actorType={actorTypeState.actorType}
            common={updatedCommonState.common}
            visible={visibleUpdateModal}
            onUpdated={() => {
              setVisibleUpdateModal(false);
              dispatch(find(page, pageSize, query));
            }}
            onCancel={() => {
              setVisibleUpdateModal(false);
            }}
          />

          {!initialDataLoaded && commonsState?.list?.length === 0 ? (
            <>
              <br />
              <br />
              <br />
              <br />
              <Empty
                image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                imageStyle={{ height: 60 }}
                description={
                  <span>
                    No tienes{" "}
                    {`${actorTypeState?.actorType?.actor || "Entidad"}`} aún
                  </span>
                }
              >
                <Button
                  icon={<PlusOutlined />}
                  onClick={() => {
                    setVisibleCreateModal(!visibleCreateModal);
                  }}
                  type="primary"
                >
                  Agregar
                </Button>
              </Empty>
              <br />
              <br />
              <br />
              <br />
            </>
          ) : (
            <>
              <Row
                gutter={[8, 8]}
                style={{
                  width: "100%",
                  marginBottom: 20,
                  alignItems: "center",
                }}
              >
                <Col xs={24} sm={12} md={8} lg={12}>
                  <Flex vertical={true} align={"flex-start"}>
                    <Search
                      placeholder="Buscar"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onSearch={handleSearch}
                      enterButton
                    />
                  </Flex>
                </Col>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <Flex vertical={true} align={"flex-end"}>
                    <Button
                      type="primary"
                      onClick={() => setVisibleCreateModal(!visibleCreateModal)}
                      size="middle"
                      icon={<PlusOutlined />}
                    >
                      Agregar
                    </Button>
                  </Flex>
                </Col>
              </Row>
              <Skeleton
                loading={commonsState.isLoading}
                active
                className="full-width"
              >
                <Table
                  scroll={{ x: 2000 }}
                  sticky={{ offsetHeader: 0 }}
                  pagination={{
                    locale: {
                      jump_to: "Ir a",
                      items_per_page: "Items por pagina",
                    },
                    total:
                      commonsState.meta?.total_count ||
                      commonsState.meta?.filter_count,
                    current: page,
                    pageSize: PageSetting.limit,
                    onChange: (page) => {
                      dispatch(find(page, pageSize, query));
                      setPage(page);
                    },
                    onShowSizeChange: (pageSize) => {
                      dispatch(find(page, pageSize, query));
                      setPageSize(pageSize);
                    },
                  }}
                  locale={{ emptyText: "Sin Resultados." }}
                  columns={columns}
                  dataSource={commonsState.list}
                />
              </Skeleton>
            </>
          )}
        </Card>
      </Content>
      <Footer />
    </Layout>
  );
};

export default Commons;
